/** Evento global de scroll (Lenis + fallback nativo) para reveals ao scroll. */
export const APP_SCROLL_EVENT = 'sosvor-scroll'

export function emitAppScroll() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(APP_SCROLL_EVENT))
}
